//

import { mapGetters, mapActions } from "vuex";
import HighlightJs from "@/directives/highlightjs.directive";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    components: {
        AQCard
    },
    directives: {
        highlightjs: HighlightJs
    },

    props: {
        data: null,
        showBtn: false
    },

    data: () => ({
        selectedApplicationPreviewCode: null
    }),

    mounted() {
        this.$store.commit(
            "smartContractDesigner/setAppBlockchainLanguage",
            this.currentApp && this.currentApp.blockchainType === "BC_HLF"
                ? "go"
                : "solidity"
        );
    },

    computed: {
        ...mapGetters("smartContractDesigner", ["appBlockchainLanguage"])
    },

    watch: {
        data: {
            handler() {
                this.selectedApplicationPreviewCode = this.data;
            }
        }

    },

    methods: {
        ...mapActions("smartContractDesigner", ["getSmartContractCode"])
    }
};
